let domLoaded = false;
let igReady = false;

function handleExperiments() {
    if (!domLoaded || !igReady) return;

}

document.addEventListener("DOMContentLoaded", () => {
    domLoaded = true;
    handleExperiments();
});

window.addEventListener("ig:ready", () => {
    igReady = true;
    handleExperiments();
});